<template>
  <v-img
    :src="src"
    :cover="cover"
    :style="[
      fullWidth ? 'width: 100%' : width !== undefined ? `width: ${width}` : '',

      fullHeight
        ? 'height: 100%'
        : height !== undefined
        ? `height: ${height}`
        : '',
      aspectRatio !== undefined ? `aspect-ratio: ${aspectRatio}` : '',
      withBg === true ? `background-color: rgb(var(--v-theme-light-grey))` : '',
    ]"
  >
    <template v-if="hideLoader !== true" v-slot:placeholder>
      <v-row align="center" class="fill-height ma-0" justify="center">
        <v-progress-circular
          color="dark-grey"
          :size="getLoaderSize()"
          indeterminate
        ></v-progress-circular>
      </v-row>
    </template>
  </v-img>
</template>

<script setup lang="ts">
import { ImageLoaderSize } from "~/core/enums";

const props = defineProps<{
  fullWidth?: boolean;
  fullHeight?: boolean;
  aspectRatio?: number | string;
  width?: string;
  withBg?: boolean;
  hideLoader?: boolean;
  height?: string;
  cover?: boolean;
  src: string;
  imageLoaderSize?: ImageLoaderSize;
}>();

function getLoaderSize(): number {
  if (props.imageLoaderSize === undefined) {
    return 30;
  }
  switch (props.imageLoaderSize) {
    case ImageLoaderSize.small:
      return 30;
    case ImageLoaderSize.medium:
      return 55;
    case ImageLoaderSize.large:
      return 80;
    default:
      return 30;
  }
}
</script>
